const CountButton = ({ title, count }) => {
    return (
        <div className="d-flex justify-content-between align-items-center mb-2">
            <h5 className="p-3 mb-0 fw-bold  fs-16">{title}</h5>
            <div className="d-flex justify-content-end mb-2">
                <div className=" rounded-8 px-3 py-1 border border-danger fs-12 fw-600 shadow-sm">
                    Total - {count ?? 0}
                </div>
            </div>
        </div>
    );
};

export default CountButton;